import styled from 'styled-components';
import { Image } from '../Image';
import { TypeStyle } from '../TypeStyle';
export const Container = styled.div `
  position: relative;
  flex: ${({ $compact }) => ($compact ? 'none' : '1')};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${({ $hasFile, $compact, theme }) => $hasFile && !$compact ? theme.color.textOverlay.transparent.fill : theme.color.fill.subtle};
  outline: none;
  transition: border 0.24s ease-in-out;
  height: ${({ $compact }) => ($compact ? 'auto' : '187px')};
  width: 358px;
  padding: ${({ $compact, theme }) => ($compact ? `${theme.spacing(4)} ${theme.spacing(5)}` : '0')};

  border-radius: ${o => o.theme.spacing(1)};
  border-style: dashed;
  border-color: ${({ $borderColor }) => $borderColor};
  border-width: 1px;

  &:hover {
    cursor: ${({ $hasFile }) => (!$hasFile ? 'pointer' : 'default')};
  }

  &:focus-visible {
    outline: 2px solid ${o => o.theme.color.effect.focus.outline.on.background};
    outline-offset: 2px;
  }
`;
export const TextContainer = styled.div `
  text-align: center;
`;
export const DeleteIcon = styled.button `
  height: ${({ theme }) => theme.spacing(8)};
  width: ${({ theme }) => theme.spacing(8)};
  padding: ${({ theme }) => theme.spacing(2)};
  line-height: ${({ theme }) => theme.spacing(2)};
  border-radius: 50px;
  position: absolute;
  right: ${({ theme }) => theme.spacing(2)};
  top: ${({ theme }) => theme.spacing(2)};
  background-color: ${o => o.theme.color.fill.subtle};
`;
export const ErrorText = styled(TypeStyle.BodySmall) `
  display: block;
  text-align: center;
  color: ${o => o.theme.color.text.critical.on.background};
  padding: ${o => o.theme.spacing(0.5)};
  line-height: 1;
`;
export const Errors = styled.div `
  width: 358px;
`;
export const PreviewContainer = styled.div `
  ${({ $numFiles }) => $numFiles > 1 &&
    `
  display: grid;
  grid-template-columns: repeat(${$numFiles}, 1fr);
  place-items: center;
  grid-template-rows: 187px;
  `}
  max-height: 100%;
  width: 100%;
  position: relative;
  border-radius: ${o => o.theme.spacing(1)};
`;
export const FilePreview = styled(Image) `
  display: block;
  height: 100%;
  width: 100%;
  object-fit: contain;
  aspect-ratio: 1 / 1;
`;
export const UploadedFileName = styled(TypeStyle.BodyNano) `
  margin-top: ${o => o.theme.spacing(1)};
  font-weight: 500;
`;
export const FileNameRow = styled.div `
  display: flex;
  align-items: center;
  gap: ${o => o.theme.spacing(4)};
  width: 100%;
`;
export const FileNameGroup = styled.div `
  display: flex;
  flex: 1;
  align-items: center;
  gap: ${o => o.theme.spacing(2)};
  min-width: 0;
`;
export const FileNameRowLabel = styled(TypeStyle.BodyNano) `
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
export const FileNameDeleteButton = styled.button `
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  padding: 0;
  background: none;
  cursor: pointer;
`;
//# sourceMappingURL=styles.js.map